// @flow
import cn from 'classnames';
import React from 'react';
import { injectIntl } from 'react-intl';

import type { FiveSymbolLocale } from '#common/utils/locale';
import type { IntlShape } from 'react-intl';

import { EditorText } from '../EditorText';
import { List } from '../List';
import './style.pcss';

type Props = {
  callToAction: {
    label: {
      [string]: string | boolean
    },
    value: Array<{
      name: string,
      url: string,
      enable: boolean
    }>,
    type: String
  },
  onBlur: Function,
  onCheckoutBlock: Function,
  locale: FiveSymbolLocale,
  isServerSideRender: boolean,
  intl: IntlShape,
}

const Platforms = ({
  callToAction, onBlur, onCheckoutBlock, locale, isServerSideRender, intl
}: Props) => {
  const { label, value } = callToAction;
  const activePlatforms = value.filter(platform => platform.enable);

  return (
    <div className='ui-site-platforms'>
      <EditorText
        size='small'
        text={label[locale]}
        locale={locale}
        onBlur={onBlur}
        isServerSideRender={isServerSideRender}
        onCheckoutBlock={onCheckoutBlock}
        field='label'
        values={callToAction}
      />
      <List>
        {
          activePlatforms.length !== 0 && activePlatforms.map(platform => {
            // eslint-disable-next-line import/no-dynamic-require
            const svg = require(`../../../assets/images/platforms/icons/${platform.name}.svg`);
            return isServerSideRender && platform.url
              ? (
                <a
                  key={platform.name}
                  className='ui-site-platforms__item'
                  href={platform.url || ''}
                  rel='noopener noreferrer'
                  target='_blank'
                  data-utm-term={platform.name}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: svg }}
                  title={intl.messages[`nav_block.hero_settings.toggle_${platform.name}`]}
                />
              )
              : (
                <button
                  key={platform.name}
                  className={
                    cn(
                      'ui-site-platforms__item',
                      platform.name,
                      { 'ui-site-platforms__item--without-url': !platform.url }
                    )
                  }
                  title={intl.messages[`nav_block.hero_settings.toggle_${platform.name}`]}
                  onClick={onCheckoutBlock}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: svg }}
                />
              );
          })
        }
      </List>
    </div>
  );
};

export default injectIntl(Platforms);
